export default __webpack_public_path__ + "6bd81aa681c3a56cd0ba8a23929c4481.jpg";